import { errorState, successState } from "./values";

interface Text {
  consentNotGiven: {
    header: string;
    body: string;
    phone_number: string;
  };
}

interface TransferStatus {
  state: string;
  response: {
    reference: string;
  };
}

export function header(transferStatus: TransferStatus, text: Text) {
  switch (transferStatus.state) {
    case successState:
      return "Transfer successful";
    case errorState:
      return "Transfer unsuccessful";
    default:
      return text.consentNotGiven.header;
  }
}
